enum WorkspaceRoleType {
  admin = 'admin',
  standard = 'standard',
  default = 'default',
}

export default WorkspaceRoleType
